import MatchedMap from 'utilities/src/matchedMap';

import { SiteVariantEnum } from '../../_variants';
import type { SiteSizeType } from '../../_size';

const buttonClassesMap = new MatchedMap([
  [SiteVariantEnum.Primary, 'text-site-neutrals-900 bg-site-neutrals-0'],
  [
    SiteVariantEnum.Secondary,
    'border-site-neutrals-0 disabled:bg-site-neutrals-500 disabled:border-site-neutrals-500 disabled:text-site-neutrals-100',
  ],
  [SiteVariantEnum.Tertiary, 'text-site-neutrals-0'],
  [SiteVariantEnum.TextOnly, 'text-site-neutrals-0'],
]);

const buttonHoverClassesMap = new MatchedMap([
  [SiteVariantEnum.Primary, 'hover:bg-site-neutrals-50'],
  [SiteVariantEnum.Secondary, 'hover:bg-site-neutrals-0 hover:text-site-neutrals-900'],
  [SiteVariantEnum.Tertiary, 'hover:text-site-neutrals-50'],
  [SiteVariantEnum.TextOnly, 'hover:text-site-neutrals-50'],
]);

const buttonActiveClassesMap = new MatchedMap([
  [SiteVariantEnum.Primary, 'active:bg-site-primary-800'],
  [SiteVariantEnum.Secondary, ''],
  [SiteVariantEnum.Tertiary, ''],
  [SiteVariantEnum.TextOnly, ''],
]);

const commonColorClasses = 'focus:shadow-site-primary-50';

/**
 * Site Theme / White Dark Button Color Variant
 */

const buttonSiteWhiteDarkTheme = (_size: SiteSizeType) => ({
  buttonSiteVariantColorClasses: [buttonClassesMap, buttonHoverClassesMap, buttonActiveClassesMap],
  buttonSiteVariantColorShadowClasses: commonColorClasses,
});

export default buttonSiteWhiteDarkTheme;
